import { FaIcon } from '@innovationnorway/component-library';
import React from 'react';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { IconLookup } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

const ReferralSent = () => {
  const { t: tOneWayIn } = useTranslation('oneWayIn');
  interface ActionDescriptionProps {
    description: string;
    iconDefinition: IconLookup;
  }

  const ActionDescription = ({ description, iconDefinition }: ActionDescriptionProps) => {
    return (
      <div>
        <div className="icon-bubble">
          <FaIcon icon={icon(iconDefinition)} />
        </div>
        <p className="margin-top--2 margin-bottom--0">{description}</p>
      </div>
    );
  };

  return (
    <>
      <h2 className="margin-bottom--6">{tOneWayIn('referral.referralSent.referralSent')}</h2>
      <div className="display--flex flex-direction--column gap--6">
        <ActionDescription
          description={tOneWayIn('referral.referralSent.sentDescription')}
          iconDefinition={{ prefix: 'fal', iconName: 'paper-plane' }}
        />
        <ActionDescription
          description={tOneWayIn('referral.referralSent.archiveDescription')}
          iconDefinition={{ prefix: 'fal', iconName: 'box-archive' }}
        />
        <ActionDescription
          description={tOneWayIn('referral.referralSent.activityLogDescription')}
          iconDefinition={{ prefix: 'fal', iconName: 'list-timeline' }}
        />
      </div>
    </>
  );
};

export default ReferralSent;
